import ItemActions from './ItemActions'

module.exports = ItemActions.create( { 
  parentName : 'project', 
  itemsName : 'apiAccessKeys',
  itemName : 'apiAccessKey',
  actionTypeBase : 'API_ACCESS', 
  parentIdKey : 'projectId', 
  humanItemName : 'Api Access' 
} )
